export { default as TEC } from './tec.svg';
export { default as Close } from './close.svg';
export { default as Alert } from './alert.svg';
export { default as Clipboard } from './clipboard.svg';
export { default as Cog } from './cog.svg';
export { default as Info } from './info.svg';
export { default as Pencil } from './pencil.svg';
export { default as Tag } from './tag.svg';
export { default as User } from './user.svg';
